module.exports = __webpack_public_path__ + "static/media/simple.3453fc9f.png";